// src/components/TokenSalePage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useAppContext } from "../context/AppContext";
// import "./TokenSalePage.scss";

const TokenSalePage = () => {
    const navigate = useNavigate();
    //   const { appState } = useAppContext();
    const fundraisingTarget = "kdd";
    const [saleType, setSaleType] = useState("fixed");
    const [marketplace, setMarketplace] = useState("OpenSea");

    const handleNext = () => {
        alert("Tokens listed for sale successfully! Redirecting...");
        navigate("/investor-engagement");
    };

    return (
        <div className="token-sale">
            <h2>List Tokens for Sale</h2>
            <p>Fundraising Target: {fundraisingTarget || "N/A"} ETH</p>
            <select onChange={(e) => setMarketplace(e.target.value)} value={marketplace}>
                <option value="OpenSea">OpenSea</option>
                <option value="Rarible">Rarible</option>
                <option value="Uniswap">Uniswap</option>
            </select>
            <select onChange={(e) => setSaleType(e.target.value)} value={saleType}>
                <option value="fixed">Fixed Price</option>
                <option value="auction">Auction</option>
                <option value="bonding-curve">Bonding Curve</option>
            </select>
            <button onClick={handleNext}>List Tokens</button>
        </div>
    );
};

export default TokenSalePage;
